var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackArrowGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.709 11.826a.915.915 0 0 0 0-1.295L3.144 6.966h13.937A.921.921 0 0 0 18 6.047a.921.921 0 0 0-.919-.918H3.135L6.7 1.564A.915.915 0 1 0 5.404.269L.27 5.404a.915.915 0 0 0 0 1.296l5.145 5.126a.915.915 0 0 0 1.295 0Z",
  fill: "#6C6C73"
})));
export default SvgBackArrowGrey;